export class TaflFailure {
    static LANDING_ON_OCCUPIED_SQUARE = () => $localize `You cannot land on an occupied square.`;
    static THRONE_IS_LEFT_FOR_GOOD = () => $localize `Once you left the central throne, you cannot return to it.`;
    static SOLDIERS_CANNOT_SIT_ON_THRONE = () => $localize `Soldiers cannot sit on the throne.`;
    static MOVE_MUST_BE_ORTHOGONAL = () => $localize `Tafl moves must be orthogonal.`;
}
